import React from 'react'
import { BrandListSpace } from 'src/types/api'
import { Container } from 'src/components/common/Container'
import { Divider } from 'src/components/common/Divider'
import { Element as ReactScrollElement } from 'react-scroll/modules'
import { Typography } from 'src/components/common/Typography'
import { Noto_body3_m12, Noto_subheading_b18 } from 'src/styles/fonts/NotoSansKrFonts'
import CouponCircleImage from 'src/components/common/CouponCircleImage'
import { BrandListPageProps } from 'src/pages/BrandListPage'
import styled, { css } from 'styled-components'
import { ellip } from 'src/styles/mixin'
import useLocalStorage from 'src/hooks/useLocalStorage.hook'
import RenderIf from 'src/components/common/RenderIf'
import { useGlobalStore } from 'src/store/zustand'

const BrandListCategoryItems = ({
  brandListData,
  brandSalePageNav,
  activeCategory,
}: Pick<BrandListPageProps, 'brandListData' | 'brandSalePageNav' | 'activeCategory'>) => {
  const [, setPrevBrandCategory] = useLocalStorage<number>('prev_brand_category', activeCategory)
  const { resetBrandSelectSortOrder } = useGlobalStore()
  return (
    <React.Fragment>
      {brandListData?.map((brandList: BrandListSpace.BrandInfoType, index: number) => {
        const { CategoryName, BrandList, CategoryNumber } = brandList
        return (
          <Container $option="flex_column" key={CategoryName}>
            <RenderIf when={index !== 0}>
              <Divider />
            </RenderIf>
            <S.BrandListCategoryContainer
              name={`${CategoryNumber}`}
              $option="flex_column"
              $lastIndex={brandListData?.length - 1 === index}
              $firstIndex={index === 0}
              as={ReactScrollElement}
            >
              <Typography $fontStyle={Noto_subheading_b18}>{CategoryName}</Typography>
              <S.BrandList.Container>
                {BrandList?.map(
                  ({ BrandName, BrandImage, BrandNumber }: BrandListSpace.BrandListType) => {
                    const onBrandClickFn = () => {
                      setPrevBrandCategory(CategoryNumber)
                      brandSalePageNav(CategoryNumber, BrandNumber, BrandName)
                      resetBrandSelectSortOrder()
                    }
                    return (
                      <S.BrandList.Items
                        key={BrandName}
                        $option="flex_column"
                        $row_gap="4px"
                        onClick={onBrandClickFn}
                      >
                        <S.BrandList.AspectRatioImage>
                          <CouponCircleImage src={BrandImage} style={S.BrandList.CircleImage} />
                        </S.BrandList.AspectRatioImage>
                        <Typography $style={S.BrandList.BrandName}>{BrandName}</Typography>
                      </S.BrandList.Items>
                    )
                  },
                )}
              </S.BrandList.Container>
            </S.BrandListCategoryContainer>
          </Container>
        )
      })}
    </React.Fragment>
  )
}
export default BrandListCategoryItems
const S = {
  BrandListCategoryContainer: styled(Container)<{ $lastIndex?: boolean; $firstIndex?: boolean }>`
    padding: ${(props) => (props.$firstIndex ? '20px 20px 30px 20px' : '30px 20px')};
    row-gap: 10px;
    min-height: ${(props) => (props.$lastIndex ? '500px' : 'unset')};
  `,
  BrandList: {
    Container: styled.section`
      display: grid;
      column-gap: 10px;
      row-gap: 16px;
      grid-template-columns: repeat(auto-fill, minmax(72px, 1fr));
    `,
    Items: styled(Container)`
      position: relative;
      cursor: pointer;
      max-width: 92px;
    `,
    AspectRatioImage: styled.section`
      padding-top: 100%;
      display: flex;
      position: relative;
    `,
    CircleImage: css`
      position: absolute;
      top: 0;
      left: 0;
      margin: 0;
      width: 100%;
      height: 100%;
      object-fit: contain;
      min-width: 72px;
    `,
    BrandName: css`
      ${ellip('line2')};
      ${Noto_body3_m12};
      text-align: center;
      word-break: keep-all;
      color: var(--black-50);
    `,
  },
}
